/**
 * HR help text for the Organization module.
 *
 * The organization structure is what everything else hangs off. A department's
 * place in the hierarchy decides which employees a head of department can see;
 * the company's fiscal dates decide the leave year quota is allotted against.
 */

const company = {
  name: "Legal company name as it should appear on payslips, letters, and reports.",
  short_name: "Used as the prefix of every employee code, for example ABC-000123. Existing employees keep the code they were given, so changing it later leaves you with two different prefixes in use.",
  shortName: "Used as the prefix of every employee code, for example ABC-000123. Existing employees keep the code they were given, so changing it later leaves you with two different prefixes in use.",
  code: "Unique code identifying this company in imports, exports, and integrations.",
  address: "Registered address printed on company documents.",
  fiscal_start: "First day of the company's financial year. Leave quota is allotted against this year, so changing it moves everyone's leave year.",
  fiscal_end: "Last day of the company's financial year.",
  currency_id: "Default currency salaries and claims are held in.",
  time_zone: "Default time zone the company works in. Dates and times are stored centrally and converted to this zone when they are shown on screen and in exports, so a wrong value makes reports read a few hours out.",
  currency: "Default currency for this company.",
  file_attachment: "Company logo. It appears on the company record and on documents generated for this company.",
  description: "Internal note about this company.",
  is_active: "Only active companies can be selected when creating employees and records.",
};

const department = {
  name: "Department name HR and employees will see across the system.",
  code: "Unique code identifying this department in imports and reports.",
  identifier: "Type of organizational unit this is, such as division or section. It groups departments of the same kind in reports.",
  parentDept: "The department this one sits under. It sets the hierarchy, so a head of this parent can see every employee in the departments beneath it.",
  hod: "Head of this department. Marking someone as head gives them visibility of everyone below this department in the hierarchy.",
  hasLimit: "Cap the number of employees allowed in this department. With the cap on, adding an employee beyond the maximum is refused with an error.",
  maxHeadCount: "The most employees this department may hold. New employees are blocked once the current count reaches this number.",
  currentHeadCount: "How many employees are in this department right now, shown for reference.",
  description: "Internal note about what this department does.",
  is_active: "Only active departments can be selected when creating or transferring employees.",
};

const branch = {
  name: "Branch name shown across the system and used in branch-based filters and reports.",
  code: "Unique code identifying this branch in imports and reports.",
  area: "Area this branch belongs to. Privileges granted by area cover every branch inside it.",
  address: "Branch address kept on record.",
  country: "Country this branch is in.",
  location: "Location this branch belongs to.",
  location_id: "Location this branch belongs to.",
  manager: "Manager responsible for this branch.",
  time_zone: "Time zone used for this branch's attendance, where it differs from the company.",
  description: "Internal note about this branch.",
  is_active: "Only active branches can be selected when creating or transferring employees.",
};

const grade = {
  name: "Grade name, such as Officer or Manager. Salary benefits and travel entitlements are attached to grades.",
  code: "Unique code identifying this grade in imports and reports.",
  has_levels: "Turn this on when the grade is divided into levels, such as Manager I and Manager II. Levels can then be managed underneath it.",
  levels: "The levels available inside this grade.",
  description: "Internal note about what this grade covers.",
  is_active: "Only active grades can be selected on an employment or a promotion.",
};

const generic = {
  name: "Name HR will see for this record in lists, filters, and reports.",
  code: "Unique code identifying this record in imports, exports, and integrations.",
  description: "Internal note explaining when this record should be used.",
  date: "Date recorded against this entry.",
  for_all: "Apply this to every employee. Turn it off to attach it to a selected group.",
  location_id: "Location this record belongs to.",
  location: "Location this record belongs to.",
  manager: "Employee responsible for this area. They are the point of contact for the branches inside it.",
  is_active: "Only active records can be selected on new entries.",
};

export const organizationTooltips = { company, department, branch, grade, generic };
export default organizationTooltips;
